<div class="render-city-row">
  <div class="render-city-row__name">
    {{ city?.city }}
  </div>

  <div *ngIf="city?.regionName" class="render-city-row__region">
    {{ city?.regionName }}
  </div>
</div>
